import { Component, Injectable, OnInit, Input, ViewChild, ElementRef, TemplateRef, Output, EventEmitter, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { TemplateService } from '../../../../../common/services/Template.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { Select2TemplateFunction, Select2OptionData } from 'ng2-select2';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from '../../../../../common/services/Search.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { TicketTypeService } from '../../../../../common/services/TicketType.service';
import { FieldService } from '../../../../../common/services/Field.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommentService } from '../../../../../common/services/Comment.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import * as _ from 'lodash';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { IvrgatewayService } from '../../../../../common/services/Ivrgateway.service';
import { environment } from 'environments/environment';
import { MailboxService } from 'app/common/services/Mailbox.service';
import { UtilityService } from 'app/common/services/Utility.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
declare const Timer: any;


@Component({
    moduleId: module.id,
    selector: "detail-ticket",
    templateUrl: './detail_ticket.component.html',
    styleUrls: ['../detail.css', './ticket.css'],
    providers: [TicketService, TemplateService, GroupService, UserService, BsModalService, SearchService
        , ServiceService, PriorityService, TicketTypeService, FieldService, UploadService, CommonService
        , CommentService, IvrgatewayService, MailboxService]
})

@Injectable()
export class DetailTicketComponent implements OnInit {
    public upload_url = environment.api_evs;
    public option_group: any = {};
    public option_agent: any = {};

    public modelGroup: any = {};
    public modelAgent: any = {};
    public no_image: any = 'assets/images/contact.png';
    public modelComment: any = { is_publish: false, attachments: [] };
    minDate = new Date();

    @Input() ticket;
    @Input() tabIndex;
    @Input() action;
    @Output('comeback') comeback = new EventEmitter();

    public model: any = { tags: [] };

    @ViewChild('templateGroup') templateGroup: ElementRef;
    @ViewChild('templateUser') templateUser: ElementRef;
    @ViewChild('templateMergeTicket') templateMergeTicket: ElementRef;

    public user: any;
    public submit_status: any = '1';
    public allStatus: any = [{ id: '', text: '' }];
    public allTemplate: any = [{ id: '', text: '' }];
    public allGroup: any = [{ id: '', text: '' }];
    public allUserGroup: any = [];
    public allAgent: any = [];
    public agentInGroup: any = [{ id: '', text: '' }];
    public allService: any = [{
        field: "service_id",
        list: [{ id: '', text: '' }]
    }];
    public allType: any = [{ id: '', text: '' }];
    public allPriority: any = [{ id: '', text: '' }];
    public allFillterGroup: any = [{ id: '', text: '' }];
    public templates: any = [];

    public modalRef: any;

    public change_requester: boolean = true; //yeu cau thay doi nguwoiwf yeu cau
    public message: { class: string, content: string } = null;

    public showAutoComplete: boolean = false;
    public userList: any = [];  //danh sach user search 
    public is_searching: boolean = false;
    public for_what: any; //nhan biet la cho truong nao nguwoiwf yeu cầu, hay chuyên viên
    public fields: any = []; //danh sách field mở rộng
    public close_tab: boolean = true; //đóng cửa sổ hay không khi submit
    public change_subject: any = false;
    public comments: any = [];


    public is_mute: boolean = false;
    public is_hold: boolean = false;
    public is_forward: boolean = false;
    public is_invite: boolean = false;
    public is_to_ACD: boolean = false;
    public is_to_IVR: boolean = false;
    public is_out_phone: boolean = false;
    public is_answered: boolean = false;
    public modelPhoneOut: any = {};
    public modelFilter: any = {};
    public modelFillterConnector: any = {};
    public connector_type: string;
    public is_load_data: boolean = false;
    public can_assign_agent_id: boolean = false;

    //pagiagion
    public list: any = [];
    public totalItem: any = 0;
    public totalPage: any = 0;
    public page_size: number = 5;
    public currentPage: number = 1;

    public modelMerge: any = {};
    public listMergeTicket: any = {};
    public totalItemMergeTicket: any = 0;
    public totalPageMergeTicket: any = 0;
    public currentPageMergeTicket: number = 1;
    public optionMerge: any = {};
    public page_size1: number = 5;
    public cdns: any = [];
    constructor(
        private router: Router,
        private ticketService: TicketService,
        private templateService: TemplateService,
        private groupService: GroupService,
        private userService: UserService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private searchService: SearchService,
        private serviceService: ServiceService,
        private priorityService: PriorityService,
        private typeService: TicketTypeService,
        private fieldService: FieldService,
        private uploadService: UploadService,
        private commonService: CommonService,
        private commentService: CommentService,
        private socketService: SocketService,
        private IvrgatewayService: IvrgatewayService,
        private mailboxService: MailboxService,
        private domSanitizer: DomSanitizer
    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
        this.listen();
    }

    ngOnInit() {
        this.is_load_data = true;
        this.option_group = {
            placeholder: { id: '', text: 'Bộ phận' },
            templateResult: this.templateResult,
            templateSelection: this.templateSelection
        }
        this.option_agent = {
            placeholder: { id: '', text: 'Chuyên viên' },
            templateResult: this.templateResult,
            templateSelection: this.templateSelection
        }
        $('.choice-template').select2({ placeholder: "--Sử dụng mẫu trả lời nhanh--" });
        this.getGroup();

        this.getAllAgent();
        this.getStatus();
        this.getTemplate();
        this.getServices();
        this.getTypes();
        this.getPriorities();
        this.getMyFields();
        if (this.action == 'new') {
            this.change_requester = true;
        } else {
            this.change_requester = false;
            // if (this.ticket) {
            //     console.log('xaa  xi', this.ticket);
            //     if (this.ticket.assign_group_id) this.getAgentInGroup(this.ticket.assign_group_id);
            //     this.ticket.cc_users = this.ticket.cc_users ? this.ticket.cc_users : [];
            //     this.ticket.follow_users = this.ticket.follow_users ? this.ticket.follow_users : [];
            //     this.ticket.exist_cc_me = this.ticket.cc_users.indexOf(this.user._id) != -1 ? true : false;
            //     this.ticket.exist_follow_me = this.ticket.follow_users.indexOf(this.user._id) != -1 ? true : false;
            //     if (this.ticket.tags && typeof this.ticket.tags == 'string') {
            //         let arr_tags = this.ticket.tags.split(',');
            //         arr_tags = _.map(arr_tags, e => {
            //             return {
            //                 displayValue: e
            //             }
            //         })
            //         this.ticket.tags = arr_tags;
            //     }
            //     this.getComment(this.ticket._id);
            // }

        }
        // load cdns
        let temps = environment.wav_cdn.split("|");
        temps.forEach(temp => {
            if (temp != null && temp.indexOf("-") != -1) {
                temp = temp.trim();
                let items = temp.split("-");
                this.cdns.push({ ip: items[0], url: items[1] });
            }
        });
        // set da lang nghe roi
        document.getElementById('ticketCallId').innerHTML = this.ticket.call_id;
    }
    listen() {
        let timer = new Timer();
        this.socketService.missionAnnounced$.subscribe(
            mission => {
                if (mission.action == 'endCall') {
                    this.is_answered = false;
                    this.endCall(mission, timer);
                }
                if (mission.action == 'answer') {
                    this.is_answered = true;
                    this.answer(mission, timer);
                }

                if (mission.action == 'hold') {
                    this.is_hold = true;
                    this.is_mute = true;
                }

                if (mission.action == 'unHold') {
                    this.is_hold = false;
                    this.is_mute = false;
                }

                if (mission.action == 'mute') {
                    this.is_mute = true;
                }

                if (mission.action == 'unMute') {
                    this.is_mute = false;
                }

                if (mission.action == "available-agent") {
                    this.list = mission.data.agents;
                }
                if (mission.action == 'ring') {
                    this.is_answered = false;
                    if (this.ticket._id == mission.data.ticketId) {
                        this.action = 'ring';
                        this.ticket.call_id = mission.data.callId;
                    } else if (this.ticket.call_id == mission.data.callId) {
                        this.action = 'ring';
                    }
                    this.ticket.receiver_id = null;
                }
            });
    }

    answer(mission, timer) {
        timer.reset();
        if (this.ticket.call_id == mission.data.callId) {
            let requester = this.ticket.request.name ? this.ticket.request.name : this.ticket.request.phone ? this.ticket.request.phone : this.ticket.request.email;
            let subject = this.ticket.subject;
            if (this.ticket.source_detail == 'CALL_INBOUND') {
                subject = "Cuộc gọi từ " + requester
            } else {
                subject = "Cuộc gọi tới " + requester
            }
            let data = {
                subject: subject,
                receiver_id: this.user._id,
                time_start: moment()
            }
            if (!this.ticket.assign_agent_id) {
                data["assign_group_id"] = this.user.group_id;
                data["assign_agent_id"] = this.user._id;
            } else {
                data["assign_group_id"] = this.ticket.assign_group_id;
                data["assign_agent_id"] = this.ticket.assign_agent_id;
            }
            setTimeout(() => {
                this.model['assign_group_id'] = data["assign_group_id"];
                this.model['assign_agent_id'] = data["assign_agent_id"];
            }, 3000);
            // oldcode
            // data["assign_group_id"] = this.user.group_id;
            // data["assign_agent_id"] = this.user._id;
            // setTimeout(() => {
            //     if (this.user._id != this.model['assign_agent_id']) {
            //         this.model['assign_group_id'] = this.user.group_id;
            //         this.model['assign_agent_id'] = this.user._id;
            //     }
            // }, 3000);
            // end oldcode
            this.ticketService.update(this.ticket._id, data).subscribe(res => {
                this.ticket.receiver_id = this.user._id;
                // if (!this.ticket.assign_agent_id) {
                //     this.changeAssigner();

                // }
                //this.changeAssigner();
                this.ticket.time_start = moment()
            });
        }
        this.is_hold = false;
        this.is_mute = false;
        timer.start();
        timer.addEventListener('secondsUpdated', function (e) {
            $('#call_time').html(timer.getTimeValues().toString());
        });
    }

    changeAssigner() {
        if (this.is_load_data) {
            setTimeout(() => {
                this.changeAssigner();
            }, 100);
        } else {
            this.changedAssignGroup({ value: this.user.group_id });
            this.changedAssignUser({ value: this.user._id })
        }
    }

    endCall(mission, timer) {
        timer.stop();
        this.is_forward = false;
        this.is_invite = false;
        this.is_to_ACD = false;
        this.is_to_IVR = false;
        this.is_out_phone = false;
        if (this.ticket.call_id == mission.data.callId) {
            //xác định tab đang gọi điện
            let _time_end = moment();
            let _finisher = mission.data.finisher || 'agent';
            let payload = {
                time_end: _time_end,
                finisher: _finisher
            };
            let requester = this.ticket.request.name ? this.ticket.request.name : this.ticket.request.phone ? this.ticket.request.phone : this.ticket.request.email;
            if (!this.ticket.receiver_id) {
                this.model.subject = payload['subject'] = "Cuộc gọi nhỡ với " + requester
            } else {
                if (this.ticket.source_detail == 'CALL_INBOUND') {
                    this.model.subject = payload['subject'] = "Cuộc gọi từ " + requester
                } else {
                    this.model.subject = payload['subject'] = "Cuộc gọi tới " + requester
                }
            }
            this.ticketService.update(this.ticket._id, payload).toPromise().then(res => {
                this.action = 'edit';
                if (this.ticket.time_start) {
                    this.ticket.time_discuss = moment.utc(moment(_time_end, "YYYY-MM-DD HH:mm:ss").diff(moment(this.ticket.time_start, "YYYY-MM-DD HH:mm:ss"))).format("HH:mm:ss")
                }
                if (!this.model.requester_id) {
                    this.model.requester_id = res.data.requester_id;
                }
                this.comeback.emit({
                    ticket: this.ticket
                })
                this.socketService.editTab(this.tabIndex, 'edit');
            });
        }
    }

    ngAfterViewInit() {
        setTimeout(function () {
            this.is_load_data = true;
            (<any>$('.inputDate')).datepicker({ format: 'yyyy-mm-dd' });
            $('.single-select').select2({ placeholder: "--Chọn một giá trị--", width: "350px" });
            $('.multi-select').select2({ placeholder: "--Chọn nhiều giá trị--", multiple: true, width: "350px" });
            $('.myselect').select2({ placeholder: "--Chọn nhiều giá trị--", multiple: true, width: "350px" });
            if (this.ticket) {
                this.ticketService.find(this.ticket._id).toPromise().then(res => {
                    if (res.status == 200 && res.error == false) {
                        if (res.data) {
                            this.model = _.assign({}, res.data);
                        } else {
                            this.model = _.assign({}, this.ticket);
                        }
                    } else {
                        this.model = _.assign({}, this.ticket);
                    }
                    if (this.model.created_at) {
                        this.minDate = new Date(this.model.created_at);
                        this.model.created_at = moment(this.model.created_at).format('YYYY-MM-DD HH:mm');
                    }
                    if (this.model.updated_at) {
                        this.model.updated_at = moment(this.model.updated_at).format('YYYY-MM-DD HH:mm');
                    }
                    if (this.model.duedate) {
                        this.model.duedate = moment(this.model.duedate).format("YYYY-MM-DD HH:mm");
                    }
                    this.model._id = this.ticket._id;
                    if (!this.model.requester_id && this.model.request) {
                        this.model.requester_id = this.model.request._id;
                    }
                    if (!this.model.request && this.model.requester_id) {
                        this.userService.find({ _id: this.model.requester_id }).toPromise().then(resUser => {
                            if (resUser.status == 200 && resUser.error == false) {
                                this.model.request = _.assign({}, resUser.data);
                            }
                        })
                    }
                    if (this.model.assign_group_id) {
                        this.agentInGroup = _.filter(this.agentInGroup, e => {
                            if (parseInt(e.group_id) == parseInt(this.model.assign_group_id)) {
                                return e;
                            }
                        })
                        
                        if (this.user.role == 'administrator') {
                            this.agentInGroup.push({
                                id: 'add',
                                text: 'Thêm mới',
                                group_id: null
                            })
                        }
                    }

                    this.model.cc_users = this.model.cc_users ? this.model.cc_users : [];
                    this.model.follow_users = this.model.follow_users ? this.model.follow_users : [];
                    this.model.exist_cc_me = this.model.cc_users.indexOf(this.user._id) != -1 ? true : false;
                    this.model.exist_follow_me = this.model.follow_users.indexOf(this.user._id) != -1 ? true : false;
                    
                    if (this.model.tags) {
                        if (typeof this.model.tags == 'string') {
                            let arr_tags = this.model.tags.split(',');
                            arr_tags = _.map(arr_tags, e => {
                                return {
                                    displayValue: e
                                }
                            })
                            this.model.tags = arr_tags;
                        }
                    } else this.model.tags = [];
                    this.renderServices();
                    this.getComment(this.model._id);
                    setTimeout(function () {
                        this.is_load_data = false;
                    }.bind(this), 1000);
                });

            }
            this.submit_status = (this.ticket && this.ticket.status) ? this.ticket.status : 1;
        }.bind(this), 1500);
        // this.action = 'ring';
        // this.ticket.receiver_id = 1;

    }

    renderServices() {
        for (let i = 0; i < this.allService.length - 1; i++) {
            const service = this.allService[i];
            if (this.model[service.field]) {
                const serviceChild = this.allService[i + 1];
                for (let j = 0; j < serviceChild.list.length; j++) {
                    if (this.model[service.field] == serviceChild.list[j].parent_id) {
                        serviceChild.displayList.push(serviceChild.list[j]);
                    }
                }
                if (serviceChild.displayList.length > 0) {
                    serviceChild.show = true;
                    serviceChild.displayList.unshift({ id: '', text: '' });
                }
            }
        }
    }

    openMergeTicket() {
        this.modelMerge = {
            filter_code: "",
            searched: false
        }
        this.listMergeTicket = [];
        this.currentPageMergeTicket = 1;
        this.totalItemMergeTicket = 0;
        this.totalPageMergeTicket = 0;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(this.templateMergeTicket, config);
        this.filterTicket();
    }

    filterTicket() {
        this.optionMerge = [];
        this.currentPageMergeTicket = 1;
        if (this.modelMerge.filter_code) {
            this.optionMerge.push({
                key: 'code',
                condition: '=',
                value: this.modelMerge.filter_code
            })
        }
        this.getListTickets({ filters: JSON.stringify(this.optionMerge) });
        this.modelMerge.searched = true;
    }

    mergeTicket(ticket: any) {
        var y = confirm("Bạn có muốn hợp nhất phiếu ghi này không?");
        if (y) {
            ticket.isMerged = true;
            let data = {
                ticketId: this.model._id,
                mergeTicketId: ticket._id
            }
            this.ticketService.merge(data).subscribe(res => {
                if (res.status == 200 && res.error == false) {
                    this.toastr.success('Hợp nhất thành công, vui lòng chờ trong giây lát để cập nhật phiếu ghi', '', {
                        timeOut: 2000,
                        positionClass: 'toast-bottom-right'
                    });
                    setTimeout(() => {
                        this.getComment(this.model._id);
                        this.filterTicket();
                    }, 4500);
                } else {
                    this.toastr.error(res.message, 'Hợp nhất phiếu ghi không thành công', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                }
                // this.modalRef.hide();
            }, error => {
                this.toastr.error(error.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });

            })
        }

    }

    getListTickets(request: any = {}, sort: any = {}) {
        this.listMergeTicket = [];
        request.offset = this.page_size1 * (this.currentPageMergeTicket <= 0 ? 0 : this.currentPageMergeTicket - 1);
        request.limit = this.page_size1;

        this.ticketService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.listMergeTicket = res.data.tickets;
                this.listMergeTicket.forEach(e => {
                    e.isMerged = false;
                })
                this.totalItemMergeTicket = res.data.total;
                var pageString = (this.totalItemMergeTicket / this.page_size1).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPageMergeTicket = totalpage;


            } else {
                this.listMergeTicket = [];
            }
        })
    }

    setPageMergeTicket(page: number) {
        if (page <= this.totalPageMergeTicket) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPageMergeTicket) {
                this.currentPageMergeTicket = page;
                this.getListTickets({ filters: JSON.stringify(this.optionMerge) });
            }
        }
        else {

            page = this.totalPageMergeTicket;
            $('#inputPage2').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPageMergeTicket) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPageMergeTicket) {
                    this.currentPageMergeTicket = page;
                    this.getListTickets({ filters: JSON.stringify(this.optionMerge) });
                }
            }
        }
    }

    goPageMergeTicket(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPageMergeTicket(toPage);
        }
    }

    _keyPressPageMergeTicket(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }


    useTemplate($event) {
        let template = _.find(this.templates, { _id: $event.value });
        if (template) {
            if (template.subject) {
                this.model.subject = template.subject
            }
            if (template.intro) {
                this.modelComment.content = template.intro;
            }
            if (template.assign && template.assign != -1) {
                if (template.assign == "[current-agent]") {
                    this.model.assign_group_id = this.user.group_id;
                    this.model.assign_agent_id = this.user._id;
                } else {
                    this.userService.find({ _id: template.assign }).subscribe(res => {
                        if (res.status == 200 && res.error == false) {
                            this.model.assign_group_id = res.data.group_id;
                            this.model.assign_agent_id = template.assign;
                        }
                    })
                }
            }
            if (template.cc && template.cc != -1) {
                if (template.cc == "[current-agent]") {
                    if (this.model['cc_users'] && this.model['cc_users'].length > 0) {
                        this.model.cc_users = _.concat(this.model.cc_users, [this.user._id]);
                    } else {
                        this.model.cc_users = [this.user._id];
                    }
                } else {
                    if (this.model['cc_users'] && this.model['cc_users'].length > 0) {
                        this.model.cc_users = _.concat(this.model.cc_users, [template.cc]);
                    } else {
                        this.model.cc_users = [template.cc];
                    }
                }
            }

            if (template.follow && template.follow != -1) {
                if (template.follow == "[current-agent]") {
                    if (this.model['follow_users'] && this.model['follow_users'].length > 0) {
                        this.model.follow_users = _.concat(this.model.follow_users, [this.user._id]);
                    } else {
                        this.model.follow_users = [this.user._id];
                    }
                } else {
                    if (this.model['follow_users'] && this.model['follow_users'].length > 0) {
                        this.model.follow_users = _.concat(this.model.follow_users, [template.follow]);
                    } else {
                        this.model.follow_users = [template.follow];
                    }
                }
            }

            if (template.priority && template.priority != -1) {
                this.model.priority_id = template.priority;
            }

            if (template.status && template.status != -1) {
                this.submit_status = template.status;
            }
        }
    }

    htmlEncode(value) {
        return $('<div/>').text(value).html();
    }

    getComment(ticket_id) {
        this.commentService.list({ where: JSON.stringify({ ticket_id: ticket_id }) }).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.comments = res.data.comments;
                this.comments.forEach(comment => {
                    // comment.content = this.htmlEncode(comment.content.replace(/<br\s*\/?>/gi, "\n")).replace(/\n/g, "<br>")
                    comment.content = this.domSanitizer.sanitize(SecurityContext.HTML, comment.content);
                    if (comment.created_at) {
                        comment.created_at = moment(comment.created_at).format("YYYY-MM-DD HH:mm");
                    }
                    // kiem tra file ghi am
                    if (comment.sems && comment.call_status == 'answer') {
                        this.cdns.forEach(cdn => {
                            let index = comment.sems.indexOf(cdn.ip);
                            if (index != -1) {
                                let temp = comment.call_id.split("-", -1)[0];
                                temp = temp.substring(temp.length - 14);
                                temp = temp.substring(0, 10);
                                comment.sems = cdn.url + "/uploads/" + temp + "/" + comment.call_id + ".wav";
                            }
                        });
                    }
                })
            } else {
                this.comments = [];
            }
        });
    }

    getMyFields() {
        this.fieldService.allField({ target: 'ticket' }).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.fields = res.data;
                this.fields.forEach(element => {
                    if (element.type == 'select') {
                        element.data.unshift("--Chọn--");
                    }
                });
            }
        })
    }

    getStatus() {
        this.ticketService.status().subscribe(res => {
            let statusList = [];
            res.data.forEach((c: any) => {
                statusList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allStatus = statusList;
        });
    }

    offAutocomplete() {
        setTimeout(function () {
            this.showAutoComplete = false;
        }.bind(this), 1000);
    }


    searchUser($event) {
        this.userList = [];
        this.model.requester_id = null;
        let keyword = $('#inputUser-' + this.tabIndex).val();

        if (keyword.length > 0) {
            this.is_searching = true;
            this.searchService.user({ keyword: keyword }).subscribe(res => {
                if (res.status == 200 && res.error == false) {
                    this.userList = res.data;
                } else {
                    this.userList = [];
                }
                this.is_searching = false;
            }, error => {
                this.showAutoComplete = false;
            })
        }
    }


    getPriorities() {
        this.priorityService.allPriority().subscribe(res => {
            let priorityList = [
                '--Chọn--', {
                    id: '',
                    text: ''
                }];
            res.data.forEach((c: any) => {
                priorityList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allPriority = priorityList;
        });
    }

    getTypes() {
        this.typeService.allTicketType().subscribe(res => {
            let typeList = [
                '--Chọn--', {
                    id: '',
                    text: ''
                }];
            res.data.forEach((c: any) => {
                typeList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allType = typeList;
        });
    }

    getServices() {
        this.serviceService.allService().subscribe(res => {
            let serviceList = [{
                field: "service_id",
                show: true,
                list: [{ id: '', text: '', parent_id: '' }],
                displayList: [{ id: '-1', text: '--Chọn--', parent_id: '' }],
                order: 0,
            }];
            res.data.forEach((c: any) => {
                if (c.parent_id) {
                    let order = -1;
                    for (let i = 0; i < serviceList.length; i++) {
                        if (order != -1) {
                            break;
                        }
                        for (let j = 0; j < serviceList[i].list.length; j++) {
                            const service = serviceList[i].list[j];
                            if (service.id == c.parent_id) {
                                order = i + 1;
                                break;
                            }
                        }
                    }
                    if (!serviceList[order]) {
                        serviceList[order] = {
                            field: "service_id" + order,
                            show: false,
                            order: order,
                            list: [{
                                text: c.name,
                                id: c.id,
                                parent_id: c.parent_id
                            }],
                            displayList: []
                        };
                    } else {
                        serviceList[order].list.push({
                            text: c.name,
                            id: c.id,
                            parent_id: c.parent_id
                        })
                    }
                } else {
                    serviceList[0].list.push({
                        text: c.name,
                        id: c.id,
                        parent_id: ''
                    })
                    if (this.ticket.source_detail) {
                        if (!c.source || c.source.indexOf(this.ticket.source_detail) > -1) {
                            serviceList[0].displayList.push({
                                text: c.name,
                                id: c.id,
                                parent_id: ''
                            })
                        }
                    } else {
                        if (!c.source || c.source.indexOf("hand") > -1) {
                            serviceList[0].displayList.push({
                                text: c.name,
                                id: c.id,
                                parent_id: ''
                            })
                        }
                    }
                }
            });
            for (let i = 1; i < serviceList.length; i++) {
                serviceList[i].displayList.unshift({
                    text: '--Chọn--',
                    id: '-1',
                    parent_id: ''
                })
            }
            this.allService = serviceList;
        });
    }

    getGroup() {
        this.groupService.allGroup().subscribe(res => {
            let groupList = [];
            let groupList_tmp = [];
            let groupUser = [];
            groupList.push({
                id: 'all',
                text: '--Chọn--'
            });
            groupList_tmp.push({
                id: 'all',
                text: '--Chọn--'
            });
            res.data.forEach((c: any) => {
                groupList.push({
                    text: c.name,
                    id: c.id,
                });
                groupList_tmp.push({
                    text: c.name,
                    id: c.id,
                });
                groupUser.push({
                    text: c.name,
                    id: c.id
                })
            });
            this.allUserGroup = groupUser;
            this.allFillterGroup = groupList_tmp;
            if (this.user.role == 'administrator') {
                groupList.push({
                    id: 'add',
                    text: 'Thêm mới'
                })
            }
            this.allGroup = groupList;
        });
    }

    changedUserGroup($event) {
        this.modelAgent.group_id = $event.value;
    }


    getAgentInGroup(assign_group_id) {
        if (assign_group_id) {
            this.userService.all({ group_id: assign_group_id }).toPromise().then(res => {
                let agentList = [
                    '--Chọn--', {
                        id: '',
                        text: ''
                    }];
                res.data.forEach((c: any) => {
                    agentList.push({
                        text: c.name,
                        id: c._id,
                    });
                });

                if (this.user.role == 'administrator') {
                    agentList.push({
                        id: 'add',
                        text: 'Thêm mới'
                    })
                }
                this.agentInGroup = agentList;
            });
        }
    }

    getAllAgent() {
        this.userService.all({}).toPromise().then(res => {
            let agentList = [
                {
                    id: '',
                    text: '',
                    email: "",
                    group_id: null
                }
            ];
            res.data.forEach((c: any) => {
                agentList.push({
                    text: c.name,
                    id: c._id,
                    email: c.email,
                    group_id: c.group_id
                });
            });

            this.allAgent = agentList;
            this.agentInGroup = agentList;
            // if (this.user.role == 'administrator') {
            //     this.agentInGroup.push({
            //         id: 'add',
            //         text: 'Thêm mới',
            //         group_id: null
            //     })
            // }
        });
    }

    filterAgent() {
        let options = [];
        if (this.modelFilter.filter_agent_phone) {
            options.push({
                key: 'phone',
                condition: '=',
                value: this.modelFilter.filter_agent_phone
            })
        }
        if (this.modelFilter.group_id) {
            options.push({
                key: 'group_id',
                condition: '=',
                value: this.modelFilter.group_id
            })
        }
        this.getStaffs({ filters: JSON.stringify(options) });

        // let options = [];
        // if (this.modelFilter.filter_agent_phone) {
        //     options.push({
        //         key: 'phone',
        //         condition: '=',
        //         value: this.modelFilter.filter_agent_phone
        //     })
        // }
        // if (this.modelFilter.room_id) {
        //     options.push({
        //         key: 'room_id',
        //         condition: '=',
        //         value: this.modelFilter.room_id
        //     })
        // }
        // this.getStaffs({ filters: JSON.stringify(options) });

        // let options = {};
        // if (this.modelFilter.filter_agent_phone) {
        //     options['phone'] = this.modelFilter.filter_agent_phone;
        // }
        // if (this.modelFilter.room_id) {
        //     options['room_id'] = this.modelFilter.group_id;
        // }
        // this.getStaffs(options);
    }

    getStaffs(request: any = {}, sort: any = {}) {
        this.list = [];
        // this.socketService.getAgentAvailable({
        //     callId: this.ticket.call_id
        // })
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.userService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.list;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;
            } else {
                this.list = [];
            }
        });
    }

    filterConnector(event: any = null) {
        this.getConnectors(this.modelFillterConnector);
    }

    getConnectors(request: any = {}, sort: any = {}) {
        this.list = [];
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        request['TYPE'] = this.connector_type == 'ivr' ? 3 : 1;
        this.IvrgatewayService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.ivrgateways;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;


            } else {
                this.list = [];
            }
        })
    }

    openFile() {
        (<any>$('#file-' + this.tabIndex)).trigger('click');
    }

    attachFile($event) {
        var files = $event.srcElement.files;
        this.uploadService.upload(files[0]).then((res: any) => {
            if (!res.error) {
                this.modelComment.attachments.push(this.commonService.file(res.data));
                $event.target.value = null;
            } else {
                this.toastr.error(res.data.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })

    }
    submit(status) {
        // if (status == 5 && (this.model.call_status == 'answer' || this.model.call_status == 'waiting') && this.model.source == 'web') {
        //     this.toastr.error('Không được đóng phiếu ghi khi chat đang diễn ra', 'Lỗi', {
        //         timeOut: 4000,
        //         positionClass: 'toast-bottom-right'
        //     });
        //     return;
        // }

        this.message = null;
        this.fields.forEach(f => {
            if (f.type == 'date' || f.type == 'select') {
                if (<any>$('#field-' + f.key + '-' + this.tabIndex).val() && <any>$('#field-' + f.key + '-' + this.tabIndex).val().trim() != '') {
                    this.model[f.key] = <any>$('#field-' + f.key + '-' + this.tabIndex).val().trim()
                }
            } else if (f.type == 'multi-select' && <any>$('#field-' + f.key + '-' + this.tabIndex).val()) {
                this.model[f.key] = <any>$('#field-' + f.key + '-' + this.tabIndex).val();
            }
        });

        if (!this.model.requester_id) {
            this.toastr.error('Người yêu cầu không được bỏ trống', 'Lỗi', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        } else if (!this.model.subject || this.model.subject.trim() == "") {
            this.toastr.error('Tiêu đề không được bỏ trống', 'Lỗi', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        } else if (!this.modelComment.content || (this.modelComment.content && this.modelComment.content.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('<br>', '').replaceAll('</br>', '').replaceAll('&nbsp;', '').trim() == "")) {
            this.toastr.error('Nội dung không được bỏ trống', 'Lỗi', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        }
        //  else if (this.modelComment.attachments && this.modelComment.attachments.length > 0 && (!this.modelComment.content || this.modelComment.content.trim() == "")) {
        //     this.toastr.error('Nội dung không được bỏ trống khi có file đính kèm', 'Lỗi', {
        //         timeOut: 4000,
        //         positionClass: 'toast-bottom-right'
        //     });
        // }
        else {
            let check = true;
            this.fields.forEach(e => {
                if (e.is_required) {
                    if (e.type == "number") {
                        if (!this.model[e.key] && this.model[e.key] != '0') {
                            check = false;
                            this.toastr.error("Thuộc tính " + e.title + " không được bỏ trống", "Lỗi", {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        }
                    } else if (e.type == "text" || e.type == "textarea" || e.type == "date") {
                        if (!this.model[e.key] || (this.model[e.key] && this.model[e.key].trim() == "")) {
                            check = false;
                            this.toastr.error("Thuộc tính " + e.title + " không được bỏ trống", "Lỗi", {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        }
                    } else if (e.type == "select") {
                        if (!this.model[e.key] || this.model[e.key] == '--Chọn--') {
                            check = false;
                            this.toastr.error("Thuộc tính " + e.title + " không được bỏ trống", "Lỗi", {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        }
                    } else if (e.type == "multi-select") {
                        if (!this.model[e.key]) {
                            check = false;
                            this.toastr.error("Thuộc tính " + e.title + " không được bỏ trống", "Lỗi", {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        }
                    }
                }
            });
            if (check) {
                var payload = _.assign({}, this.model);
                if (payload.tags && payload.tags.length > 0) {
                    let _tags_arr = [];
                    payload.tags.forEach(t => {
                        _tags_arr.push(t.displayValue);
                    });
                    let _tags = (_tags_arr.length > 0) ? _tags_arr.join(',') : null;
                    payload.tags = _tags;
                }
                delete payload.request;
                delete payload.exist_cc_me;
                delete payload.exist_follow_me;
                delete payload._id;
                delete payload.receiver;
                delete payload.assign_agent;
                payload['status'] = status;
                this.model.status = status;
                if (payload.duedate) payload.duedate = moment(payload.duedate).format('YYYY-MM-DD HH:mm');
                if (this.ticket && this.ticket._id) {
                    this.ticketService.update(this.ticket._id, payload).subscribe(res => {
                        if (res) {
                            let error = res.error;
                            if (error) {
                                this.message = { class: "alert dark alert-danger", content: "Lưu không thành công" };
                                this.toastr.error('Lưu không thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                            } else {
                                this.toastr.success('Lưu thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                                if (this.modelComment.content && this.modelComment.content.trim() != '') {
                                    this.modelComment['ticket_id'] = this.ticket._id;
                                    this.commentService.create(this.modelComment).subscribe(rs => {
                                        let attachment = "";
                                        this.modelComment.attachments.forEach(file => {
                                            attachment += file + ",";
                                        });
                                        let cc = "";
                                        this.model.cc_users.forEach(user => {
                                            if (user.email) {
                                                cc += user.email + ",";
                                            }

                                        });
                                        let bcc = "";
                                        this.model.follow_users.forEach(user => {
                                            if (user.email) {
                                                bcc += user.email + ",";
                                            }

                                        });

                                        if (this.modelComment.is_publish) {
                                            if (this.model.request && this.model.request.email) {
                                                let email = {
                                                    "attachFile": attachment,
                                                    "content": this.modelComment.content,
                                                    "emailFrom": this.ticket.email_source,
                                                    "emailMsgId": this.ticket.email_message_id,
                                                    "emailTo": this.model.request.email,
                                                    "subject": this.ticket.subject,
                                                    "tenantId": this.user.tenant_id,
                                                    "ticketId": this.ticket._id,
                                                    "username": this.user.username,
                                                    "agentId": localStorage.getItem('agentId')
                                                }
                                                this.mailboxService.postFullUrl(environment.url_email + '/sentemail', email).subscribe(res => {
                                                    console.log("sent mail to " + this.model.request.email + " status " + res.status);
                                                });
                                            } else if (this.ticket['comment_id']) {
                                                let comment = {
                                                    "attachFile": attachment,
                                                    "content": this.modelComment.content,
                                                    "pageId": this.ticket.page_id,
                                                    "pagePostId": this.ticket.page_post_id,
                                                    "commentId": this.ticket.comment_id,
                                                    "tenantId": this.user.tenant_id,
                                                    "ticketId": this.ticket._id
                                                }
                                                this.mailboxService.postFullUrl(environment.url_ottgateway + '/facebook/comment', comment).subscribe(res => {
                                                    console.log("sent comment to " + this.ticket.comment_id + " page_id " + this.ticket.page_id + " status " + res.status);
                                                });
                                            }
                                        }
                                        // do not send to agents

                                        // if (this.model['assign_agent_id']) {
                                        //     this.allAgent.forEach(agent => {
                                        //         if (agent.id == this.model['assign_agent_id']) {
                                        //             let email = {
                                        //                 "attachFile": attachment,
                                        //                 "bcc": bcc,
                                        //                 "cc": cc,
                                        //                 "content": this.modelComment.content,
                                        //                 "emailFrom": this.ticket.email_source,
                                        //                 "emailMsgId": this.ticket.email_message_id,
                                        //                 "emailTo": agent.email,
                                        //                 "subject": this.ticket.subject,
                                        //                 "tenantId": this.user.tenant_id,
                                        //                 "ticketId": this.ticket._id,
                                        //                 "username": this.user.email,
                                        //                  "agentId": localStorage.getItem('agentId')
                                        //             }
                                        //             this.mailboxService.postFullUrl(environment.url_email+'/emailgateway/sentemail', email).subscribe(res => {
                                        //                 if (res.status == 'OK') {
                                        //                     console.log("sent mail to " + agent.email);
                                        //                 }
                                        //             });
                                        //         }
                                        //     })

                                        // }
                                        this.modelComment = { is_publish: false, attachments: [] };
                                        if (['chat', 'facebook', 'email', 'zalo'].indexOf(this.ticket.source_detail) > -1) {
                                            if (status == 5 || status == 3 || (this.ticket.assign_agent_id != this.model['assign_agent_id'])) {
                                                this.ticketService.count({ source: this.ticket.source_detail, assign_id: this.ticket.assign_agent_id }).toPromise().then(res => {
                                                    if (res.status == 200 && res.error == false) {
                                                        this.socketService.execUpdateAssignMe({ assignAgentId: this.ticket.assign_agent_id, total: res.data.assign_me, source: this.ticket.source_detail });
                                                    }
                                                })
                                            }
                                        }

                                    })
                                }
                                this.socketService.reloadLastestTicket();
                                this.redirect(this.model);
                            }
                        }
                    }, error => {
                        this.toastr.error(error.message, "Lỗi", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    })
                } else {
                    if (!this.model['assign_agent_id']) {
                        if (this.user.group_id) {
                            this.changedAssignGroup({ value: this.user.group_id });
                            this.changedAssignUser({ value: this.user._id })
                            payload.assign_group_id = this.user.group_id;
                            payload.assign_agent_id = this.user._id;
                        }
                    }
                    this.ticketService.create(payload).subscribe(res => {
                        if (res) {
                            let error = res.error;
                            if (error) {
                                this.message = { class: "alert dark alert-danger", content: "Lưu không thành công" };
                                this.toastr.error('Lưu không thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                            } else {
                                this.toastr.success('Lưu thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                                if (this.modelComment.content && this.modelComment.content.trim() != '') {
                                    this.modelComment['ticket_id'] = res.data._id;
                                    let attachment = "";
                                    this.modelComment.attachments.forEach(file => {
                                        attachment += file + ",";
                                    });
                                    let cc = "";
                                    this.model.cc_users.forEach(user => {
                                        if (user.email) {
                                            cc += user.email + ",";
                                        }

                                    });
                                    let bcc = "";
                                    this.model.follow_users.forEach(user => {
                                        if (user.email) {
                                            bcc += user.email + ",";
                                        }

                                    });
                                    if (this.model['assign_agent_id']) {
                                        this.allAgent.forEach(agent => {
                                            if (agent.id == this.model['assign_agent_id']) {
                                                let email = {
                                                    "attachFile": attachment,
                                                    "bcc": bcc,
                                                    "cc": cc,
                                                    "content": this.modelComment.content,
                                                    "emailFrom": res.data.email_source,
                                                    "emailMsgId": "",
                                                    "emailTo": agent.email,
                                                    "subject": res.data.subject,
                                                    "tenantId": this.user.tenant_id,
                                                    "ticketId": res.data._id,
                                                    "username": this.user.email,
                                                    "agentId": localStorage.getItem('agentId')
                                                }
                                                this.mailboxService.postFullUrl(environment.url_email + '/sentemail', email).subscribe(res => {
                                                    if (res.status == 'OK') {
                                                        console.log("sent mail to " + agent.email);
                                                    }
                                                });
                                            }
                                        })

                                    }
                                    this.commentService.create(this.modelComment).subscribe(rs => {
                                        this.modelComment = { is_publish: false, attachments: [] };
                                    })
                                }
                                this.socketService.reloadLastestTicket();
                                this.model._id = res.data._id;
                                this.model.code = res.data.code;
                                this.redirect(this.model);
                            }
                        }
                    }, error => {
                        this.toastr.error(error.message, "Lỗi", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });

                    })
                }
            }
        }
    }

    execCall(phone) {
        if (phone.startsWith("739")) {
            phone = phone.substring(3);
        }
        if (UtilityService.isValidPhoneNumber(phone)) {
            this.socketService.execCall(phone, this.model._id, this.model.campaign_id);
        } else {
            this.toastr.error('', 'Số điện thoại không hợp lệ', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
        }
    }

    volume(value) {
        if (value == 'on') {
            if (this.ticket.source_detail == 'CALL_INBOUND') {
                this.socketService.execMute({
                    callId: this.ticket.call_id
                }, value)
            } else {
                this.socketService.execCallOutRequestAction({
                    callId: this.ticket.call_id,
                    action: 'CALL_OUT_UNMUTE'
                })
            }
        } else {
            // this.is_mute = true;
            if (this.ticket.source_detail == 'CALL_INBOUND') {
                this.socketService.execMute({
                    callId: this.ticket.call_id
                }, value)
            } else {
                this.socketService.execCallOutRequestAction({
                    callId: this.ticket.call_id,
                    action: 'CALL_OUT_MUTE'
                })
            }
        }
    }

    hold(value) {
        if (value == 'on') {
            // this.is_hold = false;
            if (this.ticket.source_detail == 'CALL_INBOUND') {
                this.socketService.execHold({
                    callId: this.ticket.call_id,
                }, value);
            } else {
                this.socketService.execCallOutRequestAction({
                    callId: this.ticket.call_id,
                    action: 'CALL_OUT_UNHOLD'
                })
            }
        } else {
            // this.is_hold = true;
            if (this.ticket.source_detail == 'CALL_INBOUND') {
                this.socketService.execHold({
                    callId: this.ticket.call_id
                }, value);
            } else {
                this.socketService.execCallOutRequestAction({
                    callId: this.ticket.call_id,
                    action: 'CALL_OUT_HOLD'
                })
            }
        }
    }

    execEndCall() {
        if (this.ticket.source_detail == 'CALL_INBOUND') {
            this.socketService.execEndCall({ callId: this.ticket.call_id })
        } else {
            this.socketService.execCallOutRequestAction({
                callId: this.ticket.call_id,
                action: 'TERMINATE'
            })
        }
    }

    toOutPhone() {
        this.is_out_phone = true;
        this.socketService.execToOutPhone({
            callId: this.ticket.call_id,
            phonenumber: this.modelPhoneOut.phone_out,
            divertType: 0
        })
    }

    toACD(url) {
        this.is_to_ACD = true;
        this.socketService.execToACD({
            callId: this.ticket.call_id,
            sipId: url,
        })
    }

    toIVR(url) {
        this.is_to_IVR = true;
        this.socketService.execToIVR({
            callId: this.ticket.call_id,
            ivrId: url,
            campaignId: 0
        })
    }

    invite(agent_id) {
        this.is_invite = true;
        this.socketService.execInvite({
            callId: this.ticket.call_id,
            fromAgentId: this.user.agent_id,
            toAgentId: agent_id,
            type: 1
        })
    }

    forward(agent_id) {
        this.is_forward = true;
        this.socketService.execForward({
            callId: this.ticket.call_id,
            fromAgentId: this.user.agent_id,
            //dropAgentId: this.user.agent_id,
            toAgentId: agent_id
        })
    }


    redirect(ticket) {
        if (this.close_tab) {
            $('#tab-' + this.tabIndex).trigger('click');
            $('.main-content').css('display', 'block');
        } else {
            console.log('back', ticket);
            this.getComment(ticket._id);
            this.change_requester = false;
            this.comeback.emit({
                ticket: ticket
            })
        }
    }

    getTemplate() {
        this.templateService.all(this.user._id).subscribe(res => {
            this.templates = res.data;
            let templateList = [{
                id: '',
                text: '--Sử dụng mẫu trả lời nhanh--'
            }];
            res.data.forEach((c: any) => {
                if (c.access_ids) {
                    c.access_ids.forEach(e => {
                        if (e.id == this.user._id || e.id == this.user.group_id) {
                            templateList.push({
                                text: c.name,
                                id: c._id,
                            });
                        }
                    })
                } else {
                    templateList.push({
                        text: c.name,
                        id: c._id,
                    });
                }

            });
            this.allTemplate = templateList;
        });
    }

    public selectUser(user) {
        this.showAutoComplete = false;
        this.model['requester_id'] = user._id;
        this.model['request'] = user;
        let input_value = user.name ? user.name : user.phone ? user.phone : user.email;
        $("#inputUser-" + this.tabIndex).val(input_value);

    }

    public addCCMe() {
        this.model['exist_cc_me'] = true;
        if (this.model['cc_users'] && this.model['cc_users'].length > 0) {
            this.model.cc_users = _.concat(this.model.cc_users, [this.user._id]);
        } else {
            this.model.cc_users = [this.user._id];
        }
    }

    public addFollowMe() {
        this.model['exist_follow_me'] = true;
        if (this.model.follow_users && this.model.follow_users.length > 0) {
            this.model.follow_users = _.concat(this.model.follow_users, [this.user._id]);
        } else {
            this.model.follow_users = [this.user._id];
        }
    }

    public changedCCUser(e: any): void {
        if (!this.is_load_data) {
            if (!e.value) {
                this.model['exist_cc_me'] = false;
            } else if (e.value.indexOf(this.user._id) != -1) {
                this.model['exist_cc_me'] = true;
            } else {
                this.model['exist_cc_me'] = false;
            }
            if (!e.value) {
                this.model['cc_users'] = [];
            } else {
                this.model['cc_users'] = e.value;
            }
            // if (e.value == 'add') {
            //     this.modelGroup = {};
            //     let config = {
            //         backdrop: true,
            //         ignoreBackdropClick: true,
            //         keyboard: false
            //     }
            //     this.modalRef = this.modalService.show(this.templateGroup, config);
            // }  else if (e.value) {
            //     this.model['cc_users'] = e.value;
            // }
        }

    }

    public changedFollowUser(e: any): void {
        if (!this.is_load_data) {
            if (!e.value) {
                this.model['exist_follow_me'] = false;
            } else if (e.value.indexOf(this.user._id) != -1) {
                this.model['exist_follow_me'] = true;
            } else {
                this.model['exist_follow_me'] = false;
            }
            if (!e.value) {
                this.model['follow_users'] = [];
            } else {
                this.model['follow_users'] = e.value;
            }
        }

    }

    public changedService(e: any, services: any): void {
        // if (e.value) {
        if (!this.is_load_data) {
            this.model[services.field] = e.value
            for (let i = services.order + 1; i < this.allService.length; i++) {
                this.model[this.allService[i].field] = null;
                this.allService[i].show = false;
                this.allService[i].displayList = [];
            }
            if (services.order + 1 < this.allService.length) {
                for (let i = 0; i < this.allService[services.order + 1].list.length; i++) {
                    const s = this.allService[services.order + 1].list[i];
                    if (s.parent_id == e.value) {
                        this.allService[services.order + 1].displayList.push(s);
                    }
                }
                if (this.allService[services.order + 1].displayList.length > 0) {
                    this.allService[services.order + 1].displayList.unshift({ id: '', text: '' });
                    this.allService[services.order + 1].show = true;
                }
                this.model[this.allService[services.order + 1].field] = this.model[this.allService[services.order + 1].field]
            }
            for (let i = 1; i < this.allService.length; i++) {
                this.allService[i].displayList.unshift({
                    text: '--Chọn--',
                    id: '-1',
                    parent_id: ''
                })
            }
        }

        // }
    }

    public changedType(e: any): void {
        // if (e.value) {
        if (!this.is_load_data) {
            this.model['type_id'] = e.value
        }

        // }
    }

    public changedPriority(e: any): void {
        // if (e.value) {
        if (!this.is_load_data) {
            this.model['priority_id'] = e.value
        }

        // }
    }

    public changedStatus(status_id) {
        if (!this.is_load_data) {
            this.submit_status = status_id;
        }

    }

    public changedValueMyField(e, key): void {
        if (!this.is_load_data) {
            if (e.value) {
                this.model[key] = e.value;

            } else {
                this.model[key] = null;
            }
            console.log(this.model[key]);
        }

    }

    public changedTemplate($event) {
    }


    public changedAssignGroup($event) {
        if (!this.is_load_data) {
            if ($event.value == 'add') {
                this.message = null;
                this.modelGroup = {};
                let config = {
                    backdrop: true,
                    ignoreBackdropClick: true,
                    keyboard: false
                }
                this.modalRef = this.modalService.show(this.templateGroup, config);
            } else if ($event.value) {
                this.model['assign_group_id'] = $event.value;
                this.agentInGroup = [{
                    id: '',
                    text: '',
                    group_id: null
                }];
                this.allAgent.forEach(e => {
                    if (parseInt(e.group_id) == parseInt($event.value)) {
                        this.agentInGroup.push(e);
                    }
                });
                console.log(this.agentInGroup)
                if (this.user.role == 'administrator') {
                    this.agentInGroup.push({
                        id: 'add',
                        text: 'Thêm mới',
                        group_id: null
                    })
                }
                // this.getAgentInGroup($event.value);
            }
            this.can_assign_agent_id = true;
            if (typeof (this.model['assign_group_id']) == 'object') {
                this.can_assign_agent_id = false;
            }
            if (this.model['assign_group_id'] == 'all') {
                this.can_assign_agent_id = false;
            }
            if (!this.model['assign_group_id']) {
                this.can_assign_agent_id = false;
            }

        }
    }

    public changedAssignUser($event) {
        if (!this.is_load_data) {
            if ($event.value == 'add') {
                this.message = null;
                this.modelAgent = { group_id: this.model.assign_group_id ? this.model.assign_group_id : null };
                let config = {
                    backdrop: true,
                    ignoreBackdropClick: true,
                    keyboard: false
                }
                this.modalRef = this.modalService.show(this.templateUser, config);
                this.for_what = 'assign_agent';
            } else if ($event.value) {
                this.model['assign_agent_id'] = $event.value;
            } else if (!$event.value) {
                this.model['assign_agent_id'] = "";
            }
        }
    }


    public changedFilterGroup(e: any): void {
        if (!this.is_load_data) {
            if (e.value) {
                this.modelFilter.group_id = e.value;
            }
        }

    }

    addGroup() {
        this.groupService.create(this.modelGroup).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Lưu không thành công" };
                    this.toastr.error('Lưu không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Lưu thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });

                    this.getGroup();
                    this.modalRef.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        })
    }

    addAgent() {
        if (this.for_what == 'assign_agent') {
            this.modelAgent['group_id'] = this.model.assign_group_id;
        }
        this.userService.create(this.modelAgent).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Lưu không thành công" };
                    this.toastr.error('Lưu không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.is_load_data = true;
                    this.toastr.success('Lưu thành công, vui lòng chờ trong giây lát để cập nhật thông tin', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });

                    if (this.for_what == 'requester') {
                        this.model.request = res.data;
                        this.model.requester_id = res.data._id;
                        setTimeout(() => {
                            this.is_load_data = false;
                        }, 1000);
                    } else if (this.for_what == 'assign_agent') {
                        // this.getAgentInGroup(this.model.assign_group_id);
                        // this.model['assign_agent_id'] = res.data._id;
                        setTimeout(() => {
                            this.getAllAgent();
                            setTimeout(() => {
                                this.getAgentInGroup(this.model.assign_group_id);
                            }, 500);
                            setTimeout(() => {
                                this.model['assign_agent_id'] = res.data._id;
                                this.is_load_data = false;
                            }, 1000);
                        }, 4500);
                    }

                    this.modalRef.hide();
                }
            }
        }, error => {
            // this.toastr.error(error.message.details[0].message, '', {
            //     timeOut: 4000,
            //     positionClass: 'toast-bottom-right'
            // });
            this.message = { class: "alert dark alert-danger", content: error.message };
            setTimeout(() => this.message = null, 3000);
        })
    }

    openNewUser(for_what) {
        this.for_what = for_what;
        this.modelAgent = { group_id: null };
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(this.templateUser, config);
    }
    // function for result template
    public templateResult: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
        if (state.id == 'add') {
            return jQuery('<i class="icon fa fa-plus"></><span class="ml-10">' + state.text + '</span>')
        } else {
            return state.text;
        }
    }

    // function for selection template
    public templateSelection: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
        if (state.id == 'add') {
            return jQuery('<i class="icon fa fa-plus"></><span class="ml-10">' + state.text + '</span>')
        } else {
            return state.text;
        }
    }

    initPage() {
        this.list = [];
        this.totalItem = 0;
        this.totalPage = 0;
        this.page_size = 5;
        this.currentPage = 1;
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.getStaffs()
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.getStaffs();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }


    setPageConnector(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.getConnectors()
            }
        }
        else {

            page = this.totalPage;
            $('#inputPageConnector').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.getConnectors();
                }
            }
        }
    }

    goPage2Connector(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPressConnector(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    delAttactment(index) {
        this.modelComment.attachments.splice(index, 1);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/tabs/ticket/detail_ticket.component.ts